import type { ReceiptTemplate } from '@/lib/templates/schema';

export interface SavedTemplateRecord {
  id: string;
  name: string;
  data: ReceiptTemplate;
  created_at: string;
  updated_at: string;
}

async function parseError(res: Response): Promise<string> {
  try {
    const body = await res.json();
    if (body && typeof body.error === 'string') return body.error;
  } catch {
    // Fall through to status text.
  }
  return res.statusText || 'Request failed';
}

export async function listSavedTemplates(): Promise<SavedTemplateRecord[]> {
  const res = await fetch('/api/templates', { cache: 'no-store' });
  if (!res.ok) throw new Error(await parseError(res));
  const body = await res.json();
  return body.templates ?? [];
}

export async function createSavedTemplate(
  name: string,
  data: ReceiptTemplate
): Promise<SavedTemplateRecord> {
  const res = await fetch('/api/templates', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, data }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  const body = await res.json();
  return body.template;
}

export async function updateSavedTemplate(
  id: string,
  updates: { name?: string; data?: ReceiptTemplate }
): Promise<SavedTemplateRecord> {
  const res = await fetch(`/api/templates/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
  if (!res.ok) throw new Error(await parseError(res));
  const body = await res.json();
  return body.template;
}

export async function deleteSavedTemplate(id: string): Promise<void> {
  const res = await fetch(`/api/templates/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(await parseError(res));
}

export async function getSavedTemplate(id: string): Promise<SavedTemplateRecord> {
  const res = await fetch(`/api/templates/${id}`, { cache: 'no-store' });
  if (!res.ok) throw new Error(await parseError(res));
  const body = await res.json();
  return body.template;
}
